/**
 * The order of the module groups in the role pickers (Invita persona, the grant panels and Ruoli),
 * the same order as the rail. «other» (roles this caller cannot place in a module) always comes last,
 * after any module this list does not know yet.
 */
export const MODULE_ORDER = [
  'administration',
  'finance',
  'expenses',
  'clinical-study',
  'identity-documents',
  'tools',
] as const;

export function moduleRank(code: string): number {
  if (code === 'other') {
    return MODULE_ORDER.length + 1;
  }
  const index = (MODULE_ORDER as readonly string[]).indexOf(code);
  return index === -1 ? MODULE_ORDER.length : index;
}
